export default async (_, props, context, info) => {
	return await context.client.firestore.query(
		{
			path: "users",
			...props
		},
		"users",
		context,
		info,
		"User",
		"ROOT"
	);
};
